import api from '../../plugins/api';

// ÐÐ¾Ð²ÑÐµ QR Ð²ÐµÐ´ÑÑ Ð¿Ð¾ ÑÐ¾ÐºÐµÐ½Ñ (GUID), ÑÑÐ°ÑÑÐµ â Ð¿Ð¾ ÑÐ¸ÑÐ»Ð¾Ð²Ð¾Ð¼Ñ id.
const getDocumentHistory = (idOrToken) => {
  const params = /^\d+$/.test(idOrToken) ? { id: idOrToken } : { token: idOrToken };
  return api.get('/api/documents/getDocumentHistory', params);
};

export default getDocumentHistory;
